module.exports = __webpack_public_path__ + "img/service-options-swoop-red.f1ec6709.jpg";